import { initSentry } from '@/config/sentry';
import Phaser from 'phaser';
import { createGameConfig } from '@/config/game';

initSentry();

const game = new Phaser.Game(createGameConfig());

document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    game.scene.scenes.forEach(scene => scene.scene.pause());
  } else {
    game.scene.scenes.forEach(scene => scene.scene.resume());
  }
  const kingdom = game.scene.getScene('Kingdom') as any;
  kingdom?.eventManager?.setTabVisible(!document.hidden);
});

window.addEventListener('beforeunload', () => {
  const kingdom = game.scene.getScene('Kingdom');
  if (kingdom && kingdom.scene.isActive()) {
    (kingdom as any).shutdown?.();
  }
});
